import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.993 11.646a9 9 0 1 0 -9.318 9.348","key":"svg-0"}],["path",{"d":"M12 7v5l1 1","key":"svg-1"}],["path",{"d":"M15 18a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}],["path",{"d":"M20.2 20.2l1.8 1.8","key":"svg-3"}]]

const IconClockSearch = createReactComponent('outline', 'clock-search', 'ClockSearch', __iconNode);

export default IconClockSearch;